export default class CartSidebar extends HTMLDivElement {

    constructor() {
        super();
        this.commentTextarea = this.querySelector(".message-textarea");
    }

    connectedCallback()
    {
        this.commentTextarea.addEventListener('blur',e => {
            HegydCore.sendRequest(this.commentTextarea.dataset.href,'GET',{
                'message' : this.commentTextarea.value
            });
        });
    }


}


// WEBPACK FOOTER //
// ./resources/assets/js/front/components/CartSidebar.js